module.exports = __webpack_public_path__ + "static/img/bg-about1.3f02836.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg-about1.png
// module id = gf9v
// module chunks = 1